export default __webpack_public_path__ + "static/media/selectedMarker.56e148c9.png";